import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const DefaultQuoteSection = styled.section`
  padding-bottom: 3rem;
  position: relative;

  & p {
    position: relative;
    z-index: 2;
    font-style: italic;
    font-weight: bold;
    padding-right: 1rem;
    font-weight: 500;
  }

  & svg {
    opacity: 0.25;
  }

  @media (min-width: 992px) {
    margin-top: -11rem;
    padding-top: 10rem;

    & p {
      padding-left: 6rem;
    }

    & blockquote p {
      font-size: 26px !important;
    }

    & svg {
      position: absolute;
      top: -3.5rem;
      left: 3rem;
    }
  }

  & > div > div > div > p:last-child {
    font-size: 20px !important;
    font-style: normal;
    font-weight: 300;
    color: #d50033 !important;
  }

  & p:last-child {
    color: #d50033 !important;
  }

  @media (max-width: 991px) {
    padding-top: 2rem;

    & p {
      font-size: 20px;
    }

    & p:last-child {
      color: #d50033 !important;
    }

    & svg {
      width: 60px;
    }
  }
`

function QuoteDefault({ quote }) {
  return (
    <DefaultQuoteSection className="position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto position-relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="96"
              height="96"
              viewBox="0 0 24 24"
            >
              <path
                d="M3.691 6.292C5.094 4.771 7.217 4 10 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 6.925 10H10a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2H3a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789zM20 20h-6a1 1 0 0 1-1-1v-5l.003-2.919c-.009-.111-.199-2.741 1.688-4.789C16.094 4.771 18.217 4 21 4h1v2.819l-.804.161c-1.37.274-2.323.813-2.833 1.604A2.902 2.902 0 0 0 17.925 10H21a1 1 0 0 1 1 1v7c0 1.103-.897 2-2 2z"
                fill="#000"
              />
            </svg>
            <ParseContent content={quote} />
          </div>
        </div>
      </div>
    </DefaultQuoteSection>
  )
}

export default QuoteDefault
